import { render } from "./DrillHoleEdgeTypeTopBottom.vue?vue&type=template&id=2ed6770e"
import script from "./DrillHoleEdgeTypeTopBottom.vue?vue&type=script&lang=js"
export * from "./DrillHoleEdgeTypeTopBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__